import { render, staticRenderFns } from "./ShiftSignatureCard.vue?vue&type=template&id=5c5df059&scoped=true&"
import script from "./ShiftSignatureCard.vue?vue&type=script&lang=js&"
export * from "./ShiftSignatureCard.vue?vue&type=script&lang=js&"
import style0 from "./ShiftSignatureCard.vue?vue&type=style&index=0&id=5c5df059&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5df059",
  null
  
)

export default component.exports